import React from "react";
import PropTypes from "prop-types";
import { Avatar as MuiAvatar } from "@mui/material";

import { generateUniqueSrc } from "../../utils/Helpers";
import { getUserInitials } from "../../utils/userInitials";
import "./Avatar.scss";

const resolveImageSrc = (imgSrc) => {
  if (imgSrc == null) return null;
  const trimmed = String(imgSrc).trim();
  if (!trimmed || trimmed === "null" || trimmed === "undefined") return null;
  return trimmed;
};

const Avatar = ({
  imgSrc,
  imgSrcAlt,
  name,
  containerClass,
  size,
  ...props
}) => {
  const resolvedSrc = resolveImageSrc(imgSrc);
  const initials = getUserInitials(name);

  return (
    <div
      className={`avatar-container ${containerClass || ""} ${
        size && size < 40 && "small-avatar"
      } ${size && size > 40 && "large-avatar"}`}
    >
      <MuiAvatar
        alt={imgSrcAlt || name}
        src={resolvedSrc ? generateUniqueSrc(resolvedSrc) : undefined}
        sx={{
          width: size,
          height: size,
        }}
        {...props}
      >
        {initials}
      </MuiAvatar>
    </div>
  );
};

Avatar.propTypes = {
  imgSrc: PropTypes.string,
  imgSrcAlt: PropTypes.string,
  name: PropTypes.string.isRequired,
  size: PropTypes.number,
  containerClass: PropTypes.string,
};

Avatar.defaultProps = {
  imgSrcAlt: "Avatar",
};

export default Avatar;
